import React, { useState, useEffect } from 'react';
import {
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  View,
  ActivityIndicator,
} from 'react-native';

import { Picker } from '@react-native-picker/picker';

import { createPlantation, updatePlantation } from '../../../../api/AllAddress ';
import BasicModalContainer from '../../../../common/components/basicmodal/BasicModalContainer';
import ModalHeader from '../../../../common/components/basicmodal/ModalHeader';
import ModalBody from '../../../../common/components/basicmodal/ModalBody';
import ModalFooter from '../../../../common/components/basicmodal/ModalFooter';
import { msgStr } from '../../../../common/constants/Message';
import { useAlertModal } from '../../../../common/hooks';
import { commonModalStyle } from '../../../../common/components/basicmodal';

const AddDeliveryChargeModal = ({ isModalVisible, details, setUpdateDeliveryChargeTrigger, closeModal }) => {
  const isUpdate = details ? true : false;

  const { showAlert } = useAlertModal();
  const [ValidMessage, setValidMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [formValues, setFormValues] = useState<any>({
    id: null,
    plantation: null,
    cr_delivery_charge: null,
    partner_delivery_charge: null,
    belongs_to: null,
  });

  useEffect(() => {
    if (isModalVisible && details) {
      setFormValues({
        id: details.id,
        plantation: details.plantation,
        cr_delivery_charge: details.cr_delivery_charge || '0.00',
        partner_delivery_charge: details.partner_delivery_charge || '0.00',
        belongs_to: details.belongs_to || null,
      })
    } else {
      setFormValues({
        id: null,
        plantation: null,
        cr_delivery_charge: null,
        partner_delivery_charge: null,
        belongs_to: null,
      })
    }
  }, [isModalVisible]);

  const updateFormValues = (key, value) => {
    setFormValues(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const AddDeliveryChargeButtonHandler = () => {
    if(!checkInput()) return;

    setIsLoading(true);

    const handleResponse = (jsonRes, status) => {
      switch (status) {
        case 201:
          showAlert('success', jsonRes.message);
          setUpdateDeliveryChargeTrigger(true);
          closeModal();
          break;
        case 409:
          showAlert('error', "This delivery charge already exists");
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          closeModal();
          break;
      }
      setIsLoading(false);
    };

    if (isUpdate) {
      updatePlantation(formValues, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    } else {
      createPlantation(formValues, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    }
  };

  const checkInput = () => {
    if (!formValues.cr_delivery_charge && !formValues.partner_delivery_charge) {
      setValidMessage('Please enter at least one delivery charge');
      return false;
    }
    const crValue = parseFloat(formValues.cr_delivery_charge);
    const partnerValue = parseFloat(formValues.partner_delivery_charge);
    
    if ((formValues.cr_delivery_charge && (isNaN(crValue) || crValue < 0)) ||
        (formValues.partner_delivery_charge && (isNaN(partnerValue) || partnerValue < 0))) {
      setValidMessage('Please enter valid delivery charges (must be >= 0)');
      return false;
    }
    
    setValidMessage('');
    return true;
  };

  return (
    <Modal
      animationType="none"
      transparent={true}
      visible={isModalVisible}
    >
      <BasicModalContainer>
        <ModalHeader label={isUpdate ? 'Update' : 'Add' + ' Delivery Charge'} closeModal={closeModal} />
        <ModalBody>
          <View>
            <Text style={styles.label}>Area</Text>
            <TextInput
              style={[styles.input, { backgroundColor: '#f5f5f5' }]}
              placeholder="Name"
              value={formValues.plantation || ''}
              editable={false}
              placeholderTextColor="#ccc"
            />
          </View>
          <View>
            <Text style={styles.label}>Belongs To</Text>
            <Picker
              style={styles.select}
              selectedValue={formValues.belongs_to || ''}
              onValueChange={(val) => {
                updateFormValues('belongs_to', val ? val : null);
              }}
            >
              <Picker.Item label="" value="" />
              <Picker.Item label="Charleston" value="charleston" />
              <Picker.Item label="Hilton Head" value="hiltonhead" />
            </Picker>
          </View>
          <View>
            <Text style={styles.label}>Delivery Charge</Text>
            <TextInput
              style={styles.input}
              placeholder="Delivery Charge"
              value={formValues.cr_delivery_charge ? String(formValues.cr_delivery_charge) : ''}
              onChangeText={val=>updateFormValues('cr_delivery_charge', val)}
              placeholderTextColor="#ccc"
              keyboardType="decimal-pad"
              onBlur={checkInput}
            />
          </View>
          <View>
            <Text style={styles.label}>Pickup Charge</Text>
            <TextInput
              style={styles.input}
              placeholder="Pickup Charge"
              value={formValues.partner_delivery_charge ? String(formValues.partner_delivery_charge) : ''}
              onChangeText={val=>updateFormValues('partner_delivery_charge', val)}
              placeholderTextColor="#ccc"
              keyboardType="decimal-pad"
              onBlur={checkInput}
              onSubmitEditing={AddDeliveryChargeButtonHandler}
            />
          </View>
          {ValidMessage.trim() != '' && <Text style={styles.message}>{ValidMessage}</Text>}
        </ModalBody>
        <ModalFooter>
          <TouchableOpacity onPress={AddDeliveryChargeButtonHandler}>
            <Text style={styles.addButton}>{isUpdate ? 'Update' : 'Add'}</Text>
          </TouchableOpacity>
        </ModalFooter>
      </BasicModalContainer>
      {isLoading && (
        <View style={styles.overlay}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}
    </Modal>
  );
};

const styles = commonModalStyle;

export default AddDeliveryChargeModal;
